import {
  Box,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  Theme,
  Tooltip,
  Zoom,
  useMediaQuery,
} from "@material-ui/core";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  CreateButton,
  Datagrid,
  DeleteWithConfirmButton,
  ExportButton,
  Filter,
  FilterProps,
  ListContextProvider,
  ListProps,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
  useNotify,
  useRefresh,
} from "react-admin";
import { DetailButton } from "../../../src/Components/DetailButton";
import { EnumField } from "../../../src/Components/EnumField";
import CreatedByField from "../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { ExcelExport } from "../../../src/Helper/ExportExcel";
import { CustomDateField } from "../../Components/CustomDateField";
import { CustomDatetime } from "../../Components/CustomDatetime";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../Constants/Constant";
import { TabbedDatagridProps } from "../../Models/TabbedDataGridProps";
import { SourceCoreInfoRequest, TitleCoreInfoRequest } from "./Source";
import CoreInfoRequestListDetail from "./CoreInfoRequestListDetail";
import { CoreInfoRequestStatusEnum, GetCoreInfoRequestStatusEnum } from "../../../src/Enums/CoreInfoRequestStatusEnum";
import { CoreInfoRequestExcelHeaders, CoreInfoRequestExcelName } from "./CoreInfoRequestExcel";
import { ConfirmButton } from "../../../src/Components/ConfirmButton";
import { Update, ThumbDown, ThumbUp } from "@material-ui/icons";
import { useAppDataProvider } from "../../../src/dataprovider";
import { CoreInfoRequestPutModel } from "./Model/CoreInfoRequestModel";
import { Form } from "react-final-form";
import CoreInfoRequestNotes from "./CoreInfoRequestNotes";
import { useStyles } from "../RequestOrder/Components/RequestOrderList/styles";
import CommentIcon from "@material-ui/icons/Comment";
import { useAuth } from "@airborne/react-admin";
import { SourceVwUser } from "../../../src/Constants/Source";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
import CopyableTableWrapper from "../../../src/Components/CopyableTableWrapper";
import { useLoading } from "../../../src/Components/Loading/useLoading";

const CoreInfoRequestFilter: FC<Omit<FilterProps, "children">> = props => (
  <Filter {...props}>
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />
    <TextInput label="Customer" source="customer__contains" alwaysOn />
    <TextInput label="Pn" source="pn__contains" alwaysOn />
    <TextInput label="Sn" source="sn__contains" alwaysOn />
    <CustomDatetime source="createdDate__gte" label="Tarih(>=)" alwaysOn />
    <CustomDatetime source="createdDate__lte" label="Tarih (<=)" alwaysOn />
  </Filter>
);

const ExportToExcel = (records, fetchRelatedRecords) => {
  fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
    const data = records.map(record => ({
      ...record,
      createdBy: `${record.createdBy} - ${createdBy[record.createdBy]?.name ?? ""}`,
    }));
    ExcelExport(
      CoreInfoRequestExcelHeaders,
      data.map(v => [
        v.refNo,
        v.customer,
        v.pn,
        v.sn,
        v.customerPo,
        v.requestedFields,
        v.accomplishDate != null ? v.accomplishDate : "",
        v.respondedDate != null ? v.respondedDate : "",
        v.rejectRemark,
        v.createdBy,
        v.createdDate,
        GetCoreInfoRequestStatusEnum.filter(x => x.Value == v.status)[0]?.Description ?? "NONE",
      ]),
      CoreInfoRequestExcelName
    );
  });
};

const ListActions = props => {
  const { user } = useAuth();

  return (
    <TopToolbar {...props}>
      {!user?.isCustomer && <CreateButton basePath={props.basePath} icon={props.icon} label={props.label} />}
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
    </TopToolbar>
  );
};

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const listContext = useListContext();
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { showLoading, hideLoading } = useLoading();
  const { user } = useAuth();
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const classes = useStyles();
  const [coreInfoRequest, setCoreInfoRequest] = React.useState<any>({});

  const RejectCoreInfoRequestButton = props => {
    const [data, setData] = useState(props.record);
    const [open, setOpen] = useState(false);
    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const UpdateCoreInfoRequestButtonClick = props => e => {
      setLoading(true);
      let coreInfoRequestModel: CoreInfoRequestPutModel = new CoreInfoRequestPutModel();

      coreInfoRequestModel.Id = data.id;
      coreInfoRequestModel.RequestId = data.requestId;
      coreInfoRequestModel.Remark = e.remark;
      coreInfoRequestModel.RequestedFields = data.requestedFields;
      coreInfoRequestModel.CoreInfoRequestDetails = [];

      coreInfoRequestModel.IsStatusUpdate = true;
      coreInfoRequestModel.IsCustomerUpdate = false;
      coreInfoRequestModel.Status = CoreInfoRequestStatusEnum.WaitingCustomer;

      dataProvider
        .putCoreInfoRequest(coreInfoRequestModel)
        .then(result => {
          notify(`Core Info Request Rejected`, "success", false, true);
          setOpen(false);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true))
        .finally(() => setLoading(false));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} size="small" onClick={handleClick}></IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reject Remark</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={UpdateCoreInfoRequestButtonClick(props)}
              render={({ handleSubmit, form, values }) => (
                <form>
                  <TextInput source="remark" label="remark" fullWidth variant="outlined" />
                  <Button label={"Reject!"} size="small" variant="contained" onClick={handleSubmit}>
                    <Update />
                  </Button>
                  <Button label={"Cancel !"} size="small" variant="contained" onClick={ClosePopup} color="secondary">
                    <Update />
                  </Button>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  React.useEffect(() => {
    if (loading) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [loading]);

  const CoreInfoRequestAcceptButtonClick = e => props => {
    setLoading(true);
    let coreInfoRequestModel: CoreInfoRequestPutModel = new CoreInfoRequestPutModel();

    coreInfoRequestModel.Id = e.id;
    coreInfoRequestModel.RequestId = e.requestId;
    coreInfoRequestModel.Remark = e.remark;
    coreInfoRequestModel.RequestedFields = e.requestedFields;
    coreInfoRequestModel.RespondedDate = e.respondedDate;
    coreInfoRequestModel.AccomplishDate = new Date();

    coreInfoRequestModel.IsStatusUpdate = true;
    coreInfoRequestModel.IsCustomerUpdate = false;
    coreInfoRequestModel.Status = CoreInfoRequestStatusEnum.Accepted;

    dataProvider
      .putCoreInfoRequest(coreInfoRequestModel)
      .then(() => {
        notify(`Core Info Request Accepted`, "success", false, true);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const CoreInfoRequestAcceptButton = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40 }}
        size="medium"
        isLoading={loading}
        click={CoreInfoRequestAcceptButtonClick(props?.record)}
      >
        <Tooltip style={{ width: 40, color: "#008000" }} TransitionComponent={Zoom} title="Accept Core Info Request">
          <ThumbUp />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const handleClose = () => {
    setIsMatchCreate(false);
  };

  const RemarkButton = ({ record }) => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick(record)}>
        <Tooltip TransitionComponent={Zoom} title="Comment">
          <CommentIcon />
        </Tooltip>
      </IconButton>
    );
  };

  const remarkOnClick = record => e => {
    e.stopPropagation();
    setCoreInfoRequest(record);
    setIsMatchCreate(true);
  };

  const Actions = props => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailButton label="Actions" resource={SourceCoreInfoRequest} {...props} />
          {!user?.isCustomer && props.record.status === CoreInfoRequestStatusEnum.Responded && (
            <CoreInfoRequestAcceptButton {...props} />
          )}
          {!user?.isCustomer && props.record.status === CoreInfoRequestStatusEnum.Responded && (
            <RejectCoreInfoRequestButton {...props}>
              <Tooltip
                style={{ width: 40, color: "#FF0000" }}
                TransitionComponent={Zoom}
                title="Reject Core Info Request"
              >
                <ThumbDown />
              </Tooltip>
            </RejectCoreInfoRequestButton>
          )}
          <RemarkButton record={props.record} />
          {!user?.isCustomer && (
            <DeleteWithConfirmButton
              {...props}
              resource={SourceCoreInfoRequest}
              confirmContent="Are you sure you want to delete this record?"
              confirmTitle="Delete Record"
              label=""
            />
          )}
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      {isXSmall ? (
        <ListContextProvider value={{ ...listContext }}>
          <></>
        </ListContextProvider>
      ) : (
        <>
          <ListContextProvider
            value={{
              ...listContext,
            }}
          >
            <CopyableTableWrapper>
              <Datagrid {...props} hasBulkActions={false} optimized expand={<CoreInfoRequestListDetail />}>
                <Actions label="Actions" props={props} />

                <TextField source="refNo" label={"Ref No"} />
                <TextField source="customer" label={"Customer Name"} />
                <TextField source="pn" label={"PN"} />
                <TextField source="sn" label={"SN"} />
                <TextField source="requestedFields" label={"Requested Fields"} />
                <CustomDateField source="accomplishDate" label={"Accomplish Date"} locales="en-GB" />
                <CustomDateField source="respondedDate" label={"Responded Date"} locales="en-GB" />
                <TextField source="remark" label={"Reject Note"} />
                <CreatedByField label="Created by" link={false} />
                <CustomDateField source="createdDate" locales="en-GB" />
                <EnumField source={"status"} label={"Status"} enumName={"CoreInfoRequestStatusEnum"} />
              </Datagrid>
            </CopyableTableWrapper>
          </ListContextProvider>
          {isMatchCreate && (
            <Grid item xs={3}>
              <Drawer
                classes={{
                  paper: classes.drawerPaper,
                }}
                variant="persistent"
                open={isMatchCreate}
                anchor="right"
                onClose={handleClose}
              >
                {isMatchCreate ? (
                  <CoreInfoRequestNotes
                    onCancel={handleClose}
                    resource="coreinforequestremarks"
                    basePath="coreinforequestremarks"
                    coreInfoRequest={coreInfoRequest}
                  />
                ) : null}
              </Drawer>
            </Grid>
          )}
        </>
      )}
    </Fragment>
  );
};

const CoreInfoRequestList: FC<ListProps> = props => (
  <PoolList
    {...props}
    title={TitleCoreInfoRequest.list}
    sort={DefaultCreatedDateSort}
    perPage={DefaultPerPageSize}
    exporter={ExportToExcel}
    actions={<ListActions />}
    filters={<CoreInfoRequestFilter />}
  >
    <TabbedDatagrid />
  </PoolList>
);

export default CoreInfoRequestList;
